import { SET_LOV } from "../constants/actionTypes";

export const setLov = (index, values) => ({
  type: SET_LOV,
  index,
  values
});
